import React from 'react';

import * as S from '../EntityReport.styles';

type TeamReadmePreviewProps = {};

export const TeamReadmePreview: React.FC<TeamReadmePreviewProps> = ({
  children,
}) => {
  return <S.Container>{children}</S.Container>;
};
